import React from 'react';

const VernamCipherTheory = () => {
    return (
        <div>
            <ul>
                <li>
                    <p>
                        The Vernam Cipher, also known as the one-time pad, is a cryptographic technique that provides perfect secrecy when used correctly. It was invented by Gilbert Vernam in 1917. The key feature of the Vernam Cipher is its use of a randomly generated key that is at least as long as the plaintext message and is used only once. This key is truly random and must never be reused.
                    </p>
                </li>
                <li>
                    <p>
                        One of the main advantages of the Vernam Cipher is its perfect secrecy, meaning that even with unlimited computational resources, an attacker cannot decipher the message without knowledge of the key. However, achieving perfect secrecy requires that the key is truly random, never reused, and is at least as long as the plaintext message.
                    </p>
                </li>
                <li>
                    <p>
                        Despite its strong security properties, the Vernam Cipher is not commonly used in practice due to the challenges of securely distributing and managing truly random keys, especially when communicating over insecure channels.
                    </p>
                </li>
            </ul>
        </div>
    );
}

export default VernamCipherTheory;
